import React, { useState, useEffect } from "react";
import { Table, Button, Form, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useAuthProvider } from "../../customHooks/authContext";
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useGet } from "../../customHooks/useGet";
import { jwtDecode } from 'jwt-decode';
import { get, post } from '../../services/Services';

const CoursesForm = ({ 
  configId,
  courseId, 
  onHide,
  eventRegistrationId,
  fetchCourseData,
  setFetchCourseData
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);  // Nuevo estado para el mensaje de éxito
  const [selectedMembers, setSelectedMembers] = useState([])
  const [totalCost, setTotalCost] = useState(0)

  const { school, token } = useAuthProvider();
  const schoolId = school?.id;
  const location = useLocation();

  const { data: membersData } = useGet(`https://ectech-software.com.ar/api/academy/schools/${schoolId}/members?page=0&size=10&order_by=surname&orientation=asc`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const { data: courseData } = useGet(
      `https://ectech-software.com.ar/api/academy/events/${configId}/courses/${courseId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

  // Función de éxito
  const onSuccess = () => {
    setSuccessMessage('Inscripción exitosa');  // Mostrar mensaje de éxito
    setFetchCourseData(!fetchCourseData)
    setTimeout(() => {
      setSuccessMessage(null); // Eliminar el mensaje después de 5 segundos
      onHide();  // Cierra el formulario
    }, 5000);
  };

  const handleMemberChange = (e) => {
    const { value, checked } = e.target;
    const participantId = value;

    const participant = {
      member: { id: participantId},
    }
  
    // Actualizar estado de participantes seleccionados
    setSelectedMembers(prev =>
      checked
          ? [...prev, participant].filter(
                (p, index, self) =>
                    self.findIndex(sp => sp.member.id === p.member.id) === index
            )
          : prev.filter(p => p.member.id !== participantId)
    )
  };

  useEffect(() => {
    setTotalCost(selectedMembers.length * courseData?.price)
  }, [selectedMembers, courseData])


  // Función para hacer el POST
  const handleSubmit = async () => {
    const payload = {
      course: {
        id: courseId
      },
      participants: selectedMembers,
      totalPrice: totalCost
    };
    setLoading(true);
    try {
      const response = await post(
        `/api/academy/events/registration/${eventRegistrationId}/courses`, 
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      onSuccess();  // Llamada a la función de éxito
    } catch (error) {
      console.error("🔴 Error al enviar la solicitud:", error.response?.data || error.message);
      setError(error.response?.data?.message || "Error en la inscripción. Intente nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="shadow-lg p-4 w-100 mt-4">
      <Card.Header className="bg-primary text-white text-center">
        <h5 className="mb-0">Inscribir Participantes a {courseData?.name} - Nivel {courseData?.level.name}</h5>
      </Card.Header>
      <Card.Body>
        {membersData?.content?.length > 0 ? (
          <Table striped bordered hover className="text-center">
            <thead className="table-secondary">
              <tr>
                <th>Seleccionar</th>
                <th>Apellido</th>
                <th>Nombre</th>
              </tr>
            </thead>
            <tbody>
              {membersData.content.map((member) => (
                <tr key={member.id}>
                  <td>
                    <Form.Check
                      type="checkbox"
                      value={member.id}
                      onChange={handleMemberChange}
                    />
                  </td>
                  <td>{member.surname}</td>
                  <td>{member.name}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p>No hay miembros disponibles.</p>
        )}
        
        <div><h5>Costo Total: $ {totalCost}</h5></div>
        
        {error && <div className="alert alert-danger">{error}</div>}
        {successMessage && <div className="alert alert-success">{successMessage}</div>} {/* Mensaje de éxito */}

        <div className="mt-3 text-end">
          <Button variant="secondary" className="me-2" onClick={onHide}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Cargando...' : 'Inscribir Seleccionados'}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CoursesForm;
